<template>
  <main>
    <Trail />
    <Container class="container--main">
      <Row>
        <ColumnUi md="9">
          <template v-if="newsLetter">
            <Title tag="h1" v-if="newsLetter">ENFEN</Title>
            <Title tag="h2" theme="primary" v-if="newsLetter">
              {{ newsLetter.title }}
            </Title>
          </template>
          <Title tag="h1" v-else>ENFEN</Title>
          <Content v-if="content" :content="content" />
          <div v-else>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Perferendis eveniet, temporibus explicabo vel et, sit sapiente
              nemo ad doloribus sint tempore repellendus tempora laborum
              veritatis voluptas aspernatur nisi quam odit?
            </p>
          </div>
        </ColumnUi>
        <!--
        <ColumnUi md="3">
          <h3>En esta sección</h3>
          <List marked>
            <li v-for="(subp, index) in subprograms" :key="index">
              <router-link
                v-if="!newsLetter || newsLetter.slug != subp.slug"
                :to="`/boletines/${subp.slug}`"
              >
                {{ subp.title }}
              </router-link>
              <span v-else>
                {{ subp.title }}
              </span>
            </li>
          </List>
        </ColumnUi>
        -->
        <ColumnUi md="3">
          <div>
            <Title tag="h3" theme="normal"><b>BOLETINES</b></Title>
            <List marked>
              <li v-for="(news, index) in sections" :key="index">
                <router-link
                  v-if="
                    (!newsLetter && news.slug != '') ||
                      (news.slug != '' && newsLetter.slug != news.slug)
                  "
                  :to="`/ENFEN/${news.slug}`"
                >
                  {{ news.title }}
                </router-link>
                <a
                  v-else-if="news.slug != ''"
                  style="text-decoration: underline; pointer-events: none;"
                >
                  {{ news.title }}
                </a>
                <span v-else class="is-muted">
                  {{ news.title }}
                </span>
              </li>
            </List>
          </div>
        </ColumnUi>
      </Row>
    </Container>
  </main>
</template>
<script>
import { getSections } from "@/enfen.js";
import Container from "@/components/ui/objects/Container";
import List from "@/components/ui/objects/List.vue";
import Row from "@/components/ui/atoms/Row.vue";
import ColumnUi from "@/components/ui/atoms/ColumnUi.vue";
import Trail from "@/components/common/Trail.vue";
import Title from "@/components/ui/atoms/Title.vue";
import Content from "@/components/common/Content.vue";
import { useRoute } from "vue-router";

export default {
  components: {
    Trail,
    Container,
    Row,
    ColumnUi,
    List,
    Title,
    Content
  },
  setup() {
    const sections = getSections();
    const route = useRoute().params.newsletter;
    const newsLetter = sections.find(
      newsletter => route != "" && newsletter.slug == route
    );
    const content = newsLetter && newsLetter.content;

    const availableYears = newsLetter && newsLetter.availableYears;
    const currentYear =
      availableYears && (useRoute().query.year || availableYears[0]);

    return {
      newsLetter,
      content,
      sections,
      availableYears,
      currentYear
    };
  }
};
</script>
